import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { LanguageCode, LanguageIso, Metadata } from '@mkp/shared/models';
import { ENVIRONMENT_PROVIDER } from '@mkp/shared/util-environment';
import { toQueryString } from '@mkp/shared/util-pagination';
import { map, Observable } from 'rxjs';

export interface MetadataQueryOptions {
  offset: number;
  rows: number;
  language: LanguageIso;
}

export type MetadataApiEndpoint =
  'education-level' | 'employment-position' | 'employment-type' | 'language' | 'language-level';

interface MetadataDto {
  id: string;
  language: string;
  text: string;
}

export interface MetadataQuery {
  filter: null;
  languages: [LanguageCode];
  latitude: null;
  longitude: null;
  offset: number;
  rows: number;
  subTypes: [];
  type: MetadataApiEndpoint;
}

export interface MetadataEnvelop {
  query: MetadataQuery;
  result: MetadataDto[];
}

export abstract class MetadataResource {
  private readonly httpClient = inject(HttpClient);
  private readonly url = inject(ENVIRONMENT_PROVIDER).api.metadata;

  constructor(private readonly endpoint: MetadataApiEndpoint) {}

  public list(queryOptions: MetadataQueryOptions): Observable<Metadata[]> {
    const queryString = queryOptions ? toQueryString(queryOptions) : '';
    const params = queryString ? `?${queryString}` : '';

    return this.httpClient
      .get<MetadataEnvelop>(`${this.url}/${this.endpoint}${params}`)
      .pipe(map(({ result }) => result.map(mapMetadata)));
  }
}

const mapMetadata = (dto: MetadataDto): Metadata => ({
  id: dto.id,
  text: dto.text,
  language: dto.language as LanguageCode,
});
